import React, {useState, useEffect} from "react";
import { Navigate } from "react-router-dom";
import { getReproductions } from "../../../api/reproductionApi";
import ReproWheel from "./adminReproductionWheel";
import { changeReproductionStatus } from "../../../api/reproductionApi";

export const AdminReproduction = () => {
  const [reproductions, setReproductions] = useState([]);

  useEffect(() => {
    loadReproductions();
  }, []);

  const loadReproductions = () => {
    getReproductions().then(data => setReproductions(data));
  };

  const handleStatusChange = async (id, newStatus, preserveDates = false) => {
  try {
    await changeReproductionStatus(id, newStatus, preserveDates);

    const fresh = await getReproductions();
    setReproductions(fresh);

  } catch (err) {
    console.error("Status change failed:", err);
    throw err;
  }
};



  return (
    <div>
      <ReproWheel reproductions={reproductions} onStatusChange={handleStatusChange} />
    </div>
  );
};